import React from 'react'
import Navbar from '../components/common/navbar'
import CourseOverview from '../components/school/courseOverview';
import Footer from '../components/common/footer'

const CoursePage = () => {
    return (
        <>
            <Navbar />
            <div className='container-fluid'>
                <CourseOverview />
            </div>

            <Footer />
        </>
    )
}

export default CoursePage;